import IconsTextNavigation from 'components/global/IconsTextNavigation'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import AddTravelConstraintModal from '../Modals/AddTravelConstraintModal'

const TravelConstraint: React.FC = () => {
  const { travelConstraintModal, setTravelConstraintModal, leagueData } =
    leagueEventStore(store => ({
      travelConstraintModal: store.travelConstraintModal,
      setTravelConstraintModal: store.setTravelConstraintModal,
      leagueData: store.leagueData,
    }))
  return (
    <>
      <div onClick={() => setTravelConstraintModal(true)}>
        <IconsTextNavigation
          iconName="Path"
          heading="Travel Constraints"
          isCompleted={
            leagueData.statuses.roundRobinsStatuses.travelConstraints
          }
        />
      </div>

      {travelConstraintModal && <AddTravelConstraintModal />}
    </>
  )
}

export default TravelConstraint
